import { CrusadeFaction } from "@/model/Enums";
import FormField, { FormFieldType } from "./FormField";
import TableHeader, { DefaultActionsHeader } from "./TableHeader";

export const CrusadeForceTableHeaders: TableHeader[] = [
  { text: "Force Name", value: "name", sortable: true },
  {
    text: "Faction",
    value: "force",
    format: (value: CrusadeFaction): string => {
      return (
        Object.entries(CrusadeFaction).find(([, val]) => val === value)?.[0] ||
        ""
      );
    },
    sortable: true,
  },
  { text: "Supply Limit", value: "supplyLimit", sortable: true },
  { text: "Requisition Points", value: "requisitionPoints", sortable: true },
  DefaultActionsHeader,
];

export const CrusadeForceFormFields: FormField[] = [
  {
    label: "Force Name",
    valueField: "name",
    type: FormFieldType.TEXT,
    required: true,
  },
  {
    label: "Player",
    valueField: "player",
    type: FormFieldType.TEXT,
  },
  {
    label: "Faction",
    valueField: "force",
    type: FormFieldType.SELECT,
    options: Object.entries(CrusadeFaction).map((tuple) => {
      return { text: tuple[0], value: tuple[1] };
    }),
    required: true,
  },
  {
    label: "Supply Limit",
    valueField: "supplyLimit",
    type: FormFieldType.NUMBER,
    required: true,
  },
  {
    label: "Requisition Points",
    valueField: "requisitionPoints",
    type: FormFieldType.NUMBER,
    required: true,
  },
];
